import { u as c } from "./ConfigService-a05d127e.mjs";
import { E as T, T as h } from "./I18nUtils-7143673a.mjs";
import { A as S } from "./Logger-b1967205.mjs";
import { p as b } from "./Constants-72ad2288.mjs";
import { p as v } from "./parsePhoneNumberWithError-dbe50dd0.mjs";
var s = /* @__PURE__ */ ((t) => (t.PERMANENT = "localstorage", t.TEMPORARY = "sessionstorage", t.COOKIE = "cookie", t))(s || {}), y = Object.defineProperty, A = (t, e, o) => e in t ? y(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o, R = (t, e, o) => (A(t, typeof e != "symbol" ? e + "" : e, o), o);
let O = class {
  constructor(e) {
    R(this, "_options"), this._options = e;
  }
  store(e, o) {
    document.cookie = `${e}=${o}`;
  }
  retrieve(e) {
    var o;
    const r = document.cookie;
    return e && r.includes(`${e}=`) ? (o = r.split(`${e}=`)[1]) == null ? void 0 : o.split(";")[0] : "";
  }
  remove(e) {
    const o = document.cookie;
    e && o.includes(`${e}=`) && (document.cookie = `${e}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`);
  }
  clearStorage() {
  }
};
const g = O;
function f(t) {
  return btoa(encodeURIComponent(t));
}
function E(t) {
  return decodeURIComponent(window == null ? void 0 : window.atob(t));
}
function i(t) {
  return typeof t == "string" ? t : JSON.stringify(t);
}
function N(t) {
  try {
    return JSON.parse(`${t}`);
  } catch {
    return t;
  }
}
var $ = Object.defineProperty, C = (t, e, o) => e in t ? $(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o, P = (t, e, o) => (C(t, typeof e != "symbol" ? e + "" : e, o), o);
class I {
  constructor(e) {
    P(this, "options"), this.options = e;
  }
  store(e, o) {
    var r;
    const n = (r = this.options) != null && r.encryption ? f(i(o)) : i(o);
    localStorage.setItem(e, n);
  }
  retrieve(e) {
    var o;
    const r = localStorage.getItem(e);
    return r && N((o = this.options) != null && o.encryption ? E(r) : r);
  }
  remove(e) {
    localStorage.removeItem(e);
  }
  clearStorage() {
    localStorage.clear();
  }
}
const m = I;
var w = Object.defineProperty, L = (t, e, o) => e in t ? w(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o, _ = (t, e, o) => (L(t, typeof e != "symbol" ? e + "" : e, o), o);
let x = class {
  constructor(e) {
    _(this, "options"), this.options = e;
  }
  store(e, o) {
    var r;
    const n = (r = this.options) != null && r.encryption ? f(i(o)) : i(o);
    sessionStorage.setItem(e, n);
  }
  retrieve(e) {
    var o;
    const r = sessionStorage.getItem(e);
    return r && N((o = this.options) != null && o.encryption ? E(r) : r);
  }
  remove(e) {
    sessionStorage.removeItem(e);
  }
  clearStorage() {
    sessionStorage.clear();
  }
};
const p = x, M = function(t, e) {
  let o = {};
  const r = S.getInstance();
  if (t)
    if (t.storageService)
      ({ storageService: o } = t), r.log("Storage Service already loaded, using existing version");
    else
      return t.storageService = o, e(o);
  return o;
}(
  typeof window == "object" && window || typeof globalThis == "object" && globalThis || void 0,
  function(t) {
    const e = {
      [s.PERMANENT]: { encryption: !0 },
      [s.TEMPORARY]: { encryption: !0 },
      [s.COOKIE]: {}
    }, o = {
      [s.PERMANENT]: new m({
        ...e[s.PERMANENT]
      }),
      [s.TEMPORARY]: new p({
        ...e[s.TEMPORARY]
      }),
      [s.COOKIE]: new g({
        ...e[s.COOKIE]
      })
    };
    return t.getStorage = (r = s.PERMANENT) => o[r], t.getLocalStorage = () => o[s.PERMANENT], t.getSessionStorage = () => o[s.TEMPORARY], t.getCookieStorage = () => o[s.COOKIE], t.setConfig = (r) => {
      for (const n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (n === s.PERMANENT && (o[n] = new m({
          ...r[n]
        })), n === s.TEMPORARY && (o[n] = new p({
          ...r[n]
        })), n === s.COOKIE && (o[n] = new g({
          ...r[n]
        })));
    }, t;
  }
), D = M, k = {
  Citizen: "CITIZEN",
  Foreigner: "FOREIGNER",
  Permanentresident: "PERMANENTRESIDENT",
  Nonresidentindian: "NONRESIDENTINDIAN"
}, B = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/, Q = /^[a-zA-Z\d'-.]*(?: [a-zA-Z\d'-.]+)*$/, V = /^[0-9()+]+$/, ee = /^(?!.*\s{2,})(?!.*\.{2,})(?!.*,{2,})(?!.*\+{2,})(?!.*#{2,})(?!^\s)(?!.*\s$)[^@#$%*()+={}\\[\];:"<>?\\|/]*$/, te = /^[a-zA-Z\d]*$/, oe = (t) => B.test(String(t).toLowerCase()), U = /^\d*$/, re = (t) => U.test(t.toString()), ne = (t) => {
  const e = { dialCode: "", number: t };
  try {
    const o = v(t);
    return o ? {
      dialCode: `+(${o.countryCallingCode})`,
      number: o.nationalNumber
    } : e;
  } catch {
    return e;
  }
}, se = (t) => {
  const e = u(t);
  return e && (e.startsWith("0") ? e : `0${e}`);
}, Y = (t) => {
  const e = u(t);
  return e.startsWith("0") ? e.substring(1) : e;
}, ae = (t, e) => {
  const o = Y(e);
  return `${t}${o}`.replace(/[()]/g, "");
}, u = (t, e) => t || e || "", ce = (t, e) => t ?? e ?? 0, ie = (t) => Array.isArray(t) ? t : [], le = (t) => t ?? {}, j = (t, e, o) => t ? e : o, ue = (t, e, o) => j(t, e, o), ge = (t, e, o) => {
  const r = `${e}${o}`, n = t(r);
  return n === r ? o : n;
}, me = (t, e, o) => o ? e : `${e}${t("profile.common.optional")}`, K = (t) => {
  const { NEXT_PUBLIC_COUNTRY: e } = c.getConfigs();
  return t.split("-").length > 1 || t === b ? t : `${t}-${e}`;
}, l = () => {
  const { NEXT_FALLBACK_LANGUAGE: t } = c.getConfigs(), e = String(t), [o] = e.split("-");
  return o;
}, pe = (t, e, o = h.SHORT_DATE, r = l()) => {
  if (!t)
    return "";
  const n = e === l() ? r : e;
  return T(
    t,
    o,
    // To show short/medium/long date format
    n
    // Date display sequence
  );
}, Z = () => {
  const { NEXT_PUBLIC_LANG_DATA: t } = c.getConfigs(), e = t ?? [], [o] = e;
  return o != null && o.locale ? K(o.locale) : l();
}, de = (t, e, o = l()) => {
  var n;
  const { NEXT_PUBLIC_COUNTRY: r } = c.getConfigs();
  return (e == null ? void 0 : e.toLowerCase()) === ((n = String(r)) == null ? void 0 : n.toLowerCase()) || t === k.Citizen ? Z() : o;
}, fe = () => {
  const t = D.getCookieStorage(), e = decodeURIComponent(t.retrieve("user-info") || "{}");
  if (e.includes("id")) {
    const o = {};
    return e.split(";").forEach((r) => {
      if (r) {
        const [n, a] = r.split("=");
        n === "act" && a ? o.act = JSON.parse(a) : n === "accounts" && a ? o.accounts = JSON.parse(a) : o[n] = a;
      }
    }), o;
  }
  return {};
}, z = (t, e) => {
  switch (e) {
    case 1:
    case 21:
    case 31:
      return t("profile.common.ordinal.first", { day: e });
    case 2:
    case 22:
      return t("profile.common.ordinal.second", { day: e });
    case 3:
    case 23:
      return t("profile.common.ordinal.third", { day: e });
    default:
      return t("profile.common.ordinal.other", { day: e });
  }
}, Ee = (t, e) => {
  if (e) {
    const o = e.getMonth(), r = e.getDate(), n = t("profile.common.months").split(","), a = z(t, r);
    return { day: r, month: o + 1, dayText: a, monthText: n[o] };
  }
  return {
    day: 1,
    month: 1,
    dayText: "",
    monthText: ""
  };
}, Ne = () => {
  const { NEXT_SSR_BASE_PATH: t } = c.getConfigs();
  return String(t);
}, Te = () => {
  const { NEXT_PUBLIC_COUNTRY: t } = c.getConfigs();
  return u(t);
}, he = async (t) => await Promise.resolve(t()), d = (t) => {
  const e = document.body.scrollHeight, o = document.getElementById(t);
  o == null || o.style.setProperty("height", `${e}px`);
}, Se = (t, e, o) => {
  d(t), e && o && d(o);
};
export {
  U as A,
  re as B,
  se as C,
  l as D,
  B as E,
  d as F,
  te as I,
  ee as S,
  Q as T,
  ie as a,
  Z as b,
  fe as c,
  he as d,
  Ee as e,
  pe as f,
  z as g,
  ae as h,
  K as i,
  ce as j,
  oe as k,
  D as l,
  k as m,
  j as n,
  me as o,
  u as p,
  ne as q,
  Y as r,
  Te as s,
  Se as t,
  le as u,
  ue as v,
  de as w,
  ge as x,
  Ne as y,
  V as z
};
//# sourceMappingURL=helper-987e5835.mjs.map
